import { Component, OnInit } from '@angular/core';
import { Subject } from "rxjs";
import { Router } from "@angular/router";
import { AdsService } from '../Services/ads.service';
import { CommonService } from '../Services/common.service';
import { AuthService } from '../Services/auth.service';
import { CookieService } from '../Services/cookie';

import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: "app-landing-page",
  templateUrl: "./landing-page.component.html",
  standalone: false,
  styleUrls: ["./landing-page.component.scss"],
})
export class LandingPageComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();
  Adsoffer: any;
  OfferCategories: any;
  OfferPaginated: any;
  FavouriteOffers: any;
  FavPaginated: any[] = [];
  Itemarray: any; heartfunction: boolean = false;
  serviceType: string = "Conventional";

  carouselOptions: OwlOptions = {
  loop: false,
  nav: false,
  dots: true,
  items: 1,
  autoWidth: false,
  autoHeight: false,
  responsive: {
    0: { items: 1 },
    600: { items: 1 },
    1000: { items: 1 }
  }
};

  constructor(private router: Router, private Ads: AdsService, public auth: AuthService, private cookieService: CookieService, private common: CommonService) { }
  activeTab: number;
  disabled;

  async ngOnInit(): Promise<any> {


    this.common.presentLoading();
    localStorage.setItem("Landingpage", "");
    this.auth.accessToken = await this.common.Get("token");
    console.log('detailuser', this.auth.detailuser)

    // this.auth.detailuser 
    // this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
    //   if(data?.status == 401){
    //     console.log("phaatgaya");

    //     await this.common.hideLoading();
    //   }
    //   else  if (data?.response?.code == 1) {
    //     this.auth.detailuser = data?.response?.content;


    //     this.GetFavouriteOffers()
    //   }
    //   else {
    //     await this.common.hideLoading();
    //     console.log("phaatgaya2");
    //     this.common.ParseErrorAlert("", "", this.router, data);
    //   }

    // })


    if (this.auth.detailuser) {
      this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
        if (data?.status == 401) {
          console.log("phaatgaya");
          await this.common.hideLoading();
        } else if (data?.response?.code == 1) {
          this.auth.detailuser = data?.response?.content;
          this.serviceType = await this.cookieService.get("sTyp", true);
          console.log("serviceTypeData", this.serviceType);
          this.GetFavouriteOffers();
        } else {
          await this.common.hideLoading();
          console.log("phaatgaya2");
          this.common.ParseErrorAlert("", "", this.router, data);
        }
      });
    } else {
      await this.common.hideLoading();
      this.Ads.GetOffersPaginated("", "", true, 1).then((data: any) => {
        if (data?.response.code == 1) {

          this.OfferPaginated = [...data.response.content.data];
          console.log(this.OfferPaginated, 'offerPaginatedPrelogin');
          // if (this.OfferPaginated.length > 0) {
          //   if (this.FavouriteOffers != null && this.FavouriteOffers != undefined) {

          //     this.OfferPaginated.forEach(element => {

          //       let Fav = this.FavouriteOffers.filter(x => x.offerid == element.id);
          //       // this.FavouriteOffers.filter(ele =>  {
          //       if (Fav.length > 0) {

          //         element['heart'] = true;

          //         // this.FavPaginated.push(element)
          //       }
          //       else {

          //         element['heart'] = false;


          //       }
          //       // })


          //     });
          //     console.log('OfferPaginatedprelogin', this.OfferPaginated)
          //   }



          // }
          console.log('FavPaginated', this.FavPaginated)
          this.common.hideLoading();

        }
        else {
          this.common.hideLoading();
          this.common.ParseErrorAlert('', 'OK', this.router, data)
        }
      })
      console.log("No data then bhaag jao");
    }


    // await Promise.all([this.GetFavouriteOffers(), this.GetOffersPaginated()])
    // this.GetOffer(),
  }

  // slideConfig = {
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   vertical: false,
  //   arrows: false,
  //   dots: true,
  //   adaptiveHeight: false,
  //   infinite: false,
  //   responsive: [
  //     {
  //       breakpoint: 992,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //         vertical: false,
  //       },
  //     },
  //     {
  //       breakpoint: 767,
  //       settings: {
  //         arrows: false,
  //       },
  //     },
  //   ],
  // };




  showModal(num) {
    this.modalObservable.next(num);
  }
  loginWithIdNum() {
    this.router.navigateByUrl("/LoginWithIdNum");
  }
  landingPageOffers() {
    this.router.navigateByUrl("/LandingPageOffers");
  }


  // GetOffer() {
  //   this.Ads.GetAds().then((data: any) => {
  //     if (data?.response.code == 1) {
  //       this.Adsoffer = data.response.content;

  //     }
  //     else {
  //       this.common.hideLoading();
  //       this.common.ParseErrorAlert('', 'OK', this.router, data)
  //     }
  //   })
  // }



  GetOffersPaginated() {


    //this.common.presentLoading();
    this.Ads.GetOffersPaginated("", "", true, 1).then((data: any) => {
      if (data?.response.code == 1) {



        // if (this.FavouriteOffers != null && this.FavouriteOffers != undefined) {

        //   this.FavouriteOffers.forEach(element => {

        //     this.OfferPaginated.forEach(ele => {
        //       if (element.id == ele.id) {
        //         this.FavPaginated.push(element)
        //       }
        //     })


        // });
        this.OfferPaginated = [...data.response.content.data];
        console.log(this.OfferPaginated, 'offerPaginated');

        if (this.OfferPaginated.length > 0) {

          if (this.FavouriteOffers != null && this.FavouriteOffers != undefined) {

            this.OfferPaginated.forEach(element => {

              let Fav = this.FavouriteOffers.filter(x => x.offerid == element.id);
              // this.FavouriteOffers.filter(ele =>  {
              if (Fav.length > 0) {

                element['heart'] = true;

                // this.FavPaginated.push(element)
              }
              else {

                element['heart'] = false;


              }
              // })


            });
            console.log('this.OfferPaginated', this.OfferPaginated)
          }


          // for (var c = 1; c <= data.response.content.totalPages; c++) {

          //   this.totalpages.push(c);
          //   console.log(this.totalpages)

          // }

        }
        console.log('this.FavPaginated', this.FavPaginated)
        this.common.hideLoading();

      }
      else {
        this.common.hideLoading();
        this.common.ParseErrorAlert('', 'OK', this.router, data)
      }
    })
  }


  async heartIcon(id) {
    this.heartfunction = true;
    this.common.presentLoading();
    await this.Ads.SaveFavourite(id, this.auth.accessToken).then((res: any) => {

      if (res?.response?.code == 1) {

        console.log('FavouriteOffersaved')
        this.heartfunction = false;
        this.common.hideLoading();
      }
      else {
        this.common.hideLoading();
        this.common.ParseErrorAlert('', "OK", this.router, res);
      }
    });
  }

  async logOut() { }



  // GetFavouriteOffersPaginated() {
  //   if (this.auth.detailuser != null) {
  //     this.Ads.GetFavouriteOffersPaginated(1, this.auth.accessToken).then((data: any) => {
  //       if (data?.response.code == 1) {

  //         this.FavouriteOffers = data.response.content.data;
  //         console.log('GetFavouriteOffers', this.FavouriteOffers)
  //       }
  //       else {
  //         this.common.hideLoading();
  //         this.common.ParseErrorAlert('', 'OK', this.router, data)
  //       }
  //     })
  //   }
  // }

  GetFavouriteOffers() {
    if (this.auth.detailuser != null) {
      this.Ads.GetFavouriteOffers(this.auth.accessToken).then((data: any) => {


        if (data?.response.code == 1) {
          this.FavouriteOffers = data.response.content;

          console.log('GetFavouriteOffers', this.FavouriteOffers)
          this.GetOffersPaginated()
        }
        else {
          this.common.hideLoading();
          this.common.ParseErrorAlert('', 'OK', this.router, data)
        }
      })
    }
  }
  Detail(item) {

    if (this.heartfunction == false) {
      this.Itemarray = item;

      // let key = this.cookieService.generateKey();
      localStorage.setItem("Landingpage", "landingpage");
      this.cookieService.set("offerdetail", JSON.stringify(item), true);
      this.cookieService.set("offerid", item.id, true);
      this.cookieService.set("offerpage", "Landing", true);

      this.router.navigateByUrl('/LandingPageOfferDetails')
    }

  }

}
